import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { surgeApi } from "@/lib/surgeApi";

const MemberContext = createContext(null);

export function MemberProvider({ children }) {
  const [member, setMember] = useState(null); // null = loading, false = signed out

  const refresh = useCallback(async () => {
    try { const { data } = await surgeApi.get("/me"); setMember(data); return data; }
    catch { setMember(false); return false; }
  }, []);

  useEffect(() => {
    if (!window.location.pathname.startsWith("/surge")) { setMember(false); return; }
    if (!localStorage.getItem("surge_token")) { setMember(false); return; }
    refresh();
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    const { data } = await surgeApi.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("surge_token", data.access_token);
    setMember(data);
    return data;
  }, []);

  const changePassword = useCallback(async (current_password, new_password) => {
    await surgeApi.post("/auth/change-password", { current_password, new_password });
    await refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    try { await surgeApi.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("surge_token");
    setMember(false);
  }, []);

  const value = useMemo(() => ({ member, setMember, login, logout, changePassword, refresh }), [member, login, logout, changePassword, refresh]);
  return <MemberContext.Provider value={value}>{children}</MemberContext.Provider>;
}

export const useMember = () => useContext(MemberContext);
